import { ArticleCardStyles } from '@dealstack/frontend/app/pages/HelpBlog/ArticleCard/ArticleCard.styles.tsx';
import { SanityRichText } from '@dealstack/frontend/app/pages/HelpBlog/SanityRichText/SanityRichText.tsx';
import { StandaloneBadge } from '@dealstack/frontend/shared/components/StandaloneBadge/StandaloneBadge.tsx';
import { Text, Title } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import type { ArticleCardProps } from './ArticleCard.types';

export const ArticleCard = ({
	title,
	articleUrl,
	mediaResolver,
	categoryName,
	categoryUrl,
	metaContent,
	previewText,
}: ArticleCardProps) => {
	const navigate = useNavigate();

	return (
		<ArticleCardStyles>
			<div className="content">
				{categoryName && categoryUrl && (
					<div className="category">
						<StandaloneBadge
							badge={{
								id: categoryUrl,
								label: categoryName,
								onBadgeClick: () => navigate(categoryUrl),
							}}
						/>
					</div>
				)}

				<Title size="h4" className="title" fw={600}>
					<Link to={articleUrl}>{title}</Link>
				</Title>

				{metaContent && (
					<div className="meta">
						<Text fz="sm">{metaContent}</Text>
					</div>
				)}

				{previewText && (
					<div className="rich-text">
						<Link to={articleUrl}>
							<SanityRichText
								value={previewText}
								mediaResolver={mediaResolver}
								hideMedia={true}
							/>
						</Link>
					</div>
				)}
			</div>
		</ArticleCardStyles>
	);
};
